import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gdxs",
  "use": "icon-gdxs-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-gdxs\"><defs><style type=\"text/css\"></style></defs><path d=\"M954.41084 16.463632 55.374372 16.463632c-29.640182 0-53.658759 24.031681-53.658759 53.671863l0 899.048564c0 29.639174 24.018577 53.669847 53.658759 53.669847l899.03546 0c29.66639 0 53.708151-24.030673 53.708151-53.669847L1008.117983 70.135495C1008.118991 40.495313 984.076222 16.463632 954.41084 16.463632zM954.41084 942.342079c0 14.818579-11.985097 26.84198-26.829884 26.84198L82.229455 969.184059c-14.820595 0-26.855084-12.023401-26.855084-26.84198L55.374372 96.977475c0-14.820595 12.03348-26.84198 26.855084-26.84198l845.351501 0c14.845795 0 26.829884 12.021385 26.829884 26.84198L954.41084 942.342079z\" p-id=\"2085\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/gdxs.svg
// module id = PVRG
// module chunks = 58